import React from 'react';

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {
    Box,
    FormControl,
    FormHelperText,
    TextField,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const Input = ({ control, label, name, type }) => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
            <FormControl error={Boolean(error)} fullWidth>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: '0.75rem',
                    }}
                >
                    <Box>
                        <MailOutlineIcon fontSize="small" />
                    </Box>
                    <TextField
                        fullWidth
                        label={label}
                        name={name}
                        type={type}
                        variant="standard"
                        {...field}
                    />
                </Box>

                {Boolean(error) && (
                    <FormHelperText>{error?.message}</FormHelperText>
                )}
            </FormControl>
        )}
    />
);

Input.propTypes = {
    control: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
};

export default Input;
